import React__default, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { cssAlertWrapper, cssAlertWrapperBlock, cssIcon, cssDescWithCloseBtn, cssAlertTitle } from './index.css.js';

const alertTitles = {
    SUCCESS: 'Success:',
    ERROR: 'Error:',
    WARNING: 'Warning:',
    INFO: 'Informational:',
    ATTENTION: 'Attention:'
};
const AlertBase = ({ white, dismiss = 0, type, float, title, hideTitle, hideIcon = false, onClose, className, block, children, resetTimerOnMouseLeave, ...divProps }) => {
    const [isDismissCancelled, setIsDismissCancelled] = useState(false);
    const timerRef = useRef(null);
    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (!isDismissCancelled) {
            timerRef.current = setTimeout(() => {
                if (!isDismissCancelled && onClose && dismiss > 0) {
                    onClose();
                }
            }, (dismiss || 0) * 1000);
        }
    }, [dismiss, isDismissCancelled, onClose]);
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    const handleMouseEnter = () => {
        if (!isDismissCancelled) {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            setIsDismissCancelled(true);
        }
    };
    const handleMouseLeave = () => {
        if (isDismissCancelled && resetTimerOnMouseLeave) {
            setIsDismissCancelled(false);
        }
    };
    const getAlertTitleBasedOnType = () => {
        if (title)
            return title;
        switch (type) {
            case 'success':
                return alertTitles.SUCCESS;
            case 'error':
                return alertTitles.ERROR;
            case 'warning':
                return alertTitles.WARNING;
            case 'info':
                return alertTitles.INFO;
            case 'attention':
                return alertTitles.ATTENTION;
            default:
                return '';
        }
    };
    const alertColors = (type) => {
        switch (type) {
            case 'success':
                return '#16a237';
            case 'error':
                return '#f2171c';
            case 'warning':
                return '#f76c1f';
            case 'info':
                return '#1e8ae7';
            case 'attention':
                return '#1e8ae7';
            default:
                return '#f2171c';
        }
    };
    return (React__default.createElement("div", { ...divProps, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: clsx(className, cssAlertWrapper, 'c-alert', `c-alert--${type}`, {
            'c-alert--white': white,
            'c-alert--float': float,
            [cssAlertWrapperBlock]: block
        }) },
        !hideIcon && (React__default.createElement("div", { className: clsx(cssIcon, {
                'icon-16-alert-bold': ['info', 'attention'].includes(type || ''),
                'icon-16-warning-bold': type === 'error',
                'icon-16-success-bold': type === 'success',
                'icon-16-info-bold': type === 'warning'
            }), style: {
                color: alertColors(type)
            } })),
        React__default.createElement("span", { className: clsx('c-alert__desc', {
                [cssDescWithCloseBtn]: !!onClose
            }) },
            hideTitle ? null : React__default.createElement("span", { className: `c-alert__title ${cssAlertTitle}` }, getAlertTitleBasedOnType()),
            children),
        onClose && React__default.createElement("span", { className: 'c-alert__close', onClick: onClose })));
};
const ErrorAlert = ({ children, ...props }) => (React__default.createElement(AlertBase, { ...props, type: 'error' }, children));
const InfoAlert = ({ children, ...props }) => (React__default.createElement(AlertBase, { ...props, type: 'info' }, children));
const AttentionAlert = ({ children, ...props }) => (React__default.createElement(AlertBase, { ...props, type: 'attention' }, children));
const SuccessAlert = ({ children, ...props }) => (React__default.createElement(AlertBase, { ...props, type: 'success' }, children));
const WarningAlert = ({ children, ...props }) => (React__default.createElement(AlertBase, { ...props, type: 'warning' }, children));

export { AlertBase, AttentionAlert, ErrorAlert, InfoAlert, SuccessAlert, WarningAlert };
//# sourceMappingURL=index.js.map
